import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';

import authService from 'services/authService';
import { AxiosError } from 'interfaces/interfaces';
import { InitStore, useInitStore } from 'stores/useInitStore';

interface ChangeEmailModalProps {
  show: boolean;
  handleClose: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedUser: any;
  csUserid: string;
  updateEmail: (actualUserId: string, newEmail: string) => void;
}

const ChangeEmailModal = ({ show, handleClose, selectedUser, csUserid, updateEmail }: ChangeEmailModalProps) => {
  const [currentEmail, setCurrentEmail] = useState<string>('');
  const [newEmail, setNewEmail] = useState<string>('');
  const [error, setError] = useState<string>('');

  const { setAppLoading } = useInitStore((state: InitStore) => ({
    setAppLoading: state.setAppLoading,
  }));

  useEffect(() => {
    if (selectedUser) {
      setCurrentEmail(selectedUser?.email);
      setNewEmail('');
    }
  }, [selectedUser]);

  const emailValidation = (value: string) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    return emailRegex.test(value);
  };

  const handleSave = async () => {
    try {
      setError('');
      setAppLoading(true);
      const ipResponse = await authService.getPublicIP();
      const params = {
        userid: selectedUser?.actualUserId,
        csUserid,
        newEmail,
        csLoginIp: ipResponse.data?.ip,
        serviceInvoker: 'customerService',
      };
      const response = await authService.changeUserEmail(params);
      if (response.status === 200) {
        handleClose();
        updateEmail(selectedUser?.actualUserId, newEmail);
      }
    } catch (error) {
      console.error(error);
      const axiosError = error as AxiosError;
      setError(axiosError?.response?.data?.statusMessage as string);
    } finally {
      setAppLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Change Email</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: '16px' }}>
        <div className="form-group">
          <div className="currentEmail">
            <label htmlFor="currentEmail">Current Email</label>
            <input
              className="form-control"
              type="text"
              name="currentEmail"
              value={currentEmail}
              onChange={(e) => setCurrentEmail(e.target.value)}
              disabled
            />
          </div>
        </div>
        <div className="form-group">
          <div className="newEmail">
            <label htmlFor="newEmail">New Email</label>
            <input
              className="form-control"
              type="text"
              name="newEmail"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
            />
          </div>
        </div>
        {error && <p className="text-danger">{error}</p>}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn agiaBlueButton-outline" onClick={handleClose}>
          Cancel
        </button>
        <button
          type="button"
          className={`btn agiaBlueButton ${!emailValidation(newEmail) && 'disabled'}`}
          onClick={handleSave}
        >
          Save Changes
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChangeEmailModal;
